import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';
import { isAuthenticated } from '../services/auth';
import { hasPermission } from '../utils/permissions';
import api from '../services/api';
import './LegalFooter.css';

const base = process.env.PUBLIC_URL || '';

/**
 * Help & About (in-app). Privacy & Terms: static pages in `public/legal/`.
 * "Help & Support" routes to the support-cases landing (same as the account
 * menu) when the tenant has the feature and the user can use it; otherwise it
 * falls back to the generic /help page (also used pre-login).
 */
function LegalFooter({ className = '' }) {
  const { tenantPath, tenantCode } = useTenantFromUrl();
  const [supportEnabled, setSupportEnabled] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) return undefined;
    let cancelled = false;
    api.get('/whoami')
      .then((res) => {
        const f = res.data?.features || {};
        if (!cancelled) setSupportEnabled(f.support_cases === true && hasPermission('support_cases.read'));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const helpTo = supportEnabled && tenantCode ? tenantPath('/lists/support-cases') : '/help';

  return (
    <footer className={`app-legal-footer ${className}`.trim()} role="contentinfo">
      <Link to={helpTo}>Help &amp; Support</Link>
      <span className="app-legal-footer-sep" aria-hidden="true">
        |
      </span>
      <Link to="/about">About</Link>
      <span className="app-legal-footer-sep" aria-hidden="true">
        |
      </span>
      <a href={`${base}/legal/privacy.html`} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      <span className="app-legal-footer-sep" aria-hidden="true">
        |
      </span>
      <a href={`${base}/legal/terms.html`} target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>
    </footer>
  );
}

export default LegalFooter;
